/* global axios */

import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_templates', { accountScoped: true });
  }

  list(inboxId, params = {}) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId, ...params },
    });
  }

  get(templateId, inboxId) {
    return axios.get(`${this.url}/${templateId}`, {
      params: { inbox_id: inboxId },
    });
  }

  create(inboxId, templateData) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      template: templateData,
    });
  }

  update(templateId, inboxId, templateData) {
    return axios.put(`${this.url}/${templateId}`, {
      inbox_id: inboxId,
      template: templateData,
    });
  }

  deleteTemplate(inboxId, templateName) {
    return axios.delete(`${this.url}/0`, {
      params: { inbox_id: inboxId, template_name: templateName },
    });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }

  // Mídia de exemplo do cabeçalho (data URL) → handle que vai na análise.
  upload(inboxId, arquivo) {
    return axios.post(`${this.url}/upload`, { inbox_id: inboxId, arquivo });
  }

  // Enviados, entregues, lidos e cliques por modelo nos últimos 30 dias.
  metricas(inboxId) {
    return axios.get(`${this.url}/metricas`, { params: { inbox_id: inboxId } });
  }

  // Nome verificado, telefone, qualidade e limite diário do número.
  numero(inboxId) {
    return axios.get(`${this.url}/numero`, { params: { inbox_id: inboxId } });
  }

  // Manda um modelo APROVADO ao cliente da conversa (WAME, 25/09/2026).
  // `dados`: { nome, idioma, parametros: [..], parametro_do_cabecalho }.
  enviarNaConversa(conversaId, dados) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversaId}/modelo_whatsapp`,
      dados
    );
  }

  generateWithAi(inboxId, { prompt, language, category }) {
    return axios.post(`${this.url}/generate`, {
      inbox_id: inboxId,
      prompt,
      language,
      category,
    });
  }
}

export default new WhatsappTemplatesAPI();
